import { action, makeObservable, observable } from 'mobx';

export class BandwidthManager {
  @observable currentBitRate = 0;

  constructor() {
    makeObservable(this);
  }

  @action setCurrentBitRate = (value) => {
    this.currentBitRate = value;
  }
}

export default new BandwidthManager();
